<h1 class="title" [style.viewTransitionName]="'title'">Blog</h1>
<p class="subtitle">
    Get the latest trends from the WondrVoices blog
</p>

<div class="tabs">
    @for (tab of tabs(); track tab) {
        <button
            [class.loading]="tab === ''"
            [class.loaded]="tab !== ''"
            [class.active]="tab === activeTab()"
            (click)="selectTab(tab)">
            {{ tab }}
        </button>
    }
</div>

@if (!isLoading()) {
    <div class="content">
        @for (post of filteredPosts(); track post.id) {
            <div class="blog-card" [routerLink]="['/blogs', post.id]">
                <span class="tag">{{ post.tag }}</span>
                <h3>{{ post.header }}</h3>
                <p>{{ post.subHeader }}</p>
                <a [routerLink]="['/blogs', post.id]">Read our story →</a>
            </div>
        }
        @if (posts().length === 0 && !isLoading()) {
            <div class="no-posts">
                <h2>No posts found</h2>
                <p>We couldn't find any posts with the tag "{{ activeTab() }}".</p>
            </div>
        }
        @if (filteredPosts().length % 2 === 1 && filteredPosts().length !== 1) {
            <div class="blog-card blog-card--mock"></div>
        }
    </div>
} @else {
    <div class="content">
        <div class="loader-wave">
            <div class="wave-dot"></div>
            <div class="wave-dot"></div>
            <div class="wave-dot"></div>
            <div class="wave-dot"></div>
            <div class="wave-dot"></div>
        </div>
    </div>
}
